import { render, staticRenderFns } from "./MarketStartupsModal.vue?vue&type=template&id=411feed9&scoped=true&"
import script from "./MarketStartupsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./MarketStartupsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411feed9",
  null
  
)

export default component.exports